import React, { useState, useEffect } from 'react';

// Video embed component optimized for maximum compatibility across browsers.
const VideoEmbed = ({ videoId, className = '', style = {}, thumbnail, allow, title = 'Tutorial video' }) => {
  const [loaded, setLoaded] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const thumb = thumbnail || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const iframeSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&rel=0&modestbranding=1`;

  return (
    <div className={`video-embed ${className}`} style={{ position: 'relative', ...style }}>
      <div style={{ width: '100%', position: 'relative', paddingTop: '56.25%', background: '#000' }}>
        {!loaded ? (
          <button
            type="button"
            onClick={() => setLoaded(true)}
            aria-label="Play tutorial video"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
              margin: 0,
              padding: 0,
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `url(${thumb})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'brightness(0.6)',
              }}
            />

            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
              }}
            >
              <svg
                width="80"
                height="80"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="48"
                  stroke="rgba(255,255,255,0.85)"
                  strokeWidth="3"
                  fill="rgba(0,0,0,0.35)"
                />
                <polygon points="40,30 70,50 40,70" fill="white" />
              </svg>
            </div>
          </button>
        ) : (
          <>
            {!iframeLoaded && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: 'white',
                  fontSize: '16px',
                }}
              >
                Loading video...
              </div>
            )}
            <iframe
              className="tutorial-video-iframe"
              title={title}
              src={iframeSrc}
              frameBorder="0"
              allow={
                allow ||
                'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              }
              allowFullScreen
              onLoad={() => setIframeLoaded(true)}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: iframeLoaded ? 'block' : 'none',
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default VideoEmbed;